module.exports = __webpack_public_path__ + "static/media/Contact_Icon.ef518425.svg";